import { render, staticRenderFns } from "./GoBackPopup.vue?vue&type=template&id=cafe7746&scoped=true"
import script from "./GoBackPopup.vue?vue&type=script&lang=js"
export * from "./GoBackPopup.vue?vue&type=script&lang=js"
import style0 from "./GoBackPopup.vue?vue&type=style&index=0&id=cafe7746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafe7746",
  null
  
)

export default component.exports